import * as React from 'react';

/**
 * Иконка стрелочки, повернутой вправо.
 * Наследует цвет родителя и подстраивается под его размер.
 */
export const ArrowRight: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.0297852 9.0195V6.92111L12.1181 6.92111L7.62286 2.37743L9.04464 0.970825L15.9685 7.9693L9.04464 14.9678L7.62286 13.5612L12.1161 9.0195H0.0297852Z"
        fill="currentColor"
      />
    </svg>
  );
};
